import emailjs from 'emailjs-com';
import { Row, Col } from 'antd';
import { useState } from 'react';
import DefaultLayout from '../components/DefaultLayout';
import '../contact.css';

function Contact() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [emailSent, setEmailSent] = useState(false);

    const submit = () => {
        if (name && email && subject && message) {
            const serviceId = 'service_l0cwf2l';
            const templateId = 'template_jrevzxf';
            const userId = 'MfUdUR_sljAESG-YH';
            const templateParams = {
                name,
                email,
                subject,
                message
            };

            emailjs.send(serviceId, templateId, templateParams, userId)
                .then(response => console.log(response))
                .then(error => console.log(error));

            setName('');
            setEmail('');
            setSubject('');
            setMessage('');
            setEmailSent(true);
        } else {
            alert('Please fill in all fields correctly!');
        }
    };

    // const isValidEmail = email => {
    //     const regex = '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$';
    //     return regex.test(String(email).toLowerCase());
    // };

    return (
        <DefaultLayout>
            <Row gutter={24} justify='center'>
                <Col lg={16} sm={24} xs={24} className='mt-5'>

                    <h2>Welcome to our Contact Page.</h2>

                    <div className='p-4' id="contact-form">                        
                        <h4 className="text-center">Fill out the form below to send us a message.</h4>

                        {/* <!-- name --> */}
                        <div className="form-group mt-2">
                            <label htmlFor="name">Name</label>
                            <input 
                                type="text"
                                className="form-control"
                                placeholder="Enter Your Name" 
                                value={name} 
                                onChange={e => setName(e.target.value)} 
                            />

                        </div>

                        {/* <!-- email --> */}
                        <div className="form-group">
                            <label htmlFor="email">Email address</label>
                            <input
                                type="email" 
                                className="form-control"
                                placeholder="Your email address" 
                                value={email} 
                                onChange={e => setEmail(e.target.value)} 
                            />

                        </div>

                        {/* <!-- subject --> */}
                        <div className="form-group">
                            <label htmlFor="subject">Subject</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="enter email subject"
                                value={subject}
                                onChange={e => setSubject(e.target.value)}
                            />
                        </div>

                        {/* Email message */}
                        <div className="form-group">
                            <label htmlFor="email_body">Message</label>
                            <textarea 
                                className="form-control"
                                placeholder="Enter Your message" 
                                value={message} 
                                onChange={e => setMessage(e.target.value)}>
                            </textarea>

                        </div>
                        <button onClick={submit}>Send Message</button>
                        <span className={emailSent ? 'visible' : null}> Thank you for your message, we will be in touch in no time!</span>

                    </div>
                </Col>
            </Row>
        </DefaultLayout>
    );
}

export default Contact;